<template>
    <div class="row my-3">
        <div :class="'mb-2 col-md-6 ' + headerColOrder">
            <h4>
                <strong>
                    <slot name="header"></slot>
                </strong>
            </h4>
            <div class="border border-1 border-dark" style="width: 25%;"></div>
        </div>
        <div class="col-md-6">
            <p class="text-muted">
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        headerPlacement: {default: 'left'},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        headerColOrder() {
            return this.headerPlacement === 'left' ? 'order-md-first' : 'order-first order-md-last';
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>

</style>
